import React from 'react';
import './checkoutUpsell.css'

const CheckoutUpsell = ({addUpsellPrice, upsellData}) => {
  const { 
    name, 
    priceTTC,
    description, 
    includedOptions
  } = upsellData

  return (
    <div className="checkoutUpsell-condition-box">
      <div className="checkoutUpsell-cbx-head">
        <h2 className="checkoutUpsell-title">{name}</h2>
        <label htmlFor="check9" className="checkoutUpsell-priceWrapper">
          <input className="checkoutUpsell-priceCheckBox" type="checkbox"  onClick={addUpsellPrice} />
          <span className="checkoutUpsell-price">{`+${priceTTC}€`}</span>
        </label>
      </div>
      <div className="packContent">
        {
          description.map((item,index) => <p key={`description_part_${index + 1}`}>{item}</p>)
          
        }
        {
          includedOptions.map((option, index) => {
            const { heading, text, list } = option
            return (
              <div key={`included_option_${index + 1}`}>
                <h4 className="checkoutUpsell-option">{heading}</h4>
                <p>{text}</p>
                { list && (
                  <ul>
                    {list.map((item,index) => (
                      <li key={`list_item_${index + 1}`}>{item}</li>
                    ))}
                  </ul>  
                )}
              </div>
            )}
          )
        }
      </div>
    </div>
  )  
}

export default CheckoutUpsell;



// WEBPACK FOOTER //
// ./src/components/buy/Checkout/CheckoutUpsell.js